import axios from 'axios'

export default class Mandatos {
  constructor (tokenBearer, url, id) {
    this.url = `${url}/api/unimed/mandatos/${id}`
    this.tipoMandatoUrl = `${url}/api/unimed/mandatos/tipoMandato/${id}`
    this.urlEdicao = `${url}/api/unimed/mandatos/iniciarEdicao/${id}`
    this.urlUltimo = `${url}/api/unimed/mandatos/dirigentes/ultimoMandato/${id}`
    this.tokenBearer = tokenBearer
  }

  async getMandatos (args) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async putMandatos (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async delMandatos (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'delete',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getTipoMandato () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.tipoMandatoUrl,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async iniciarEdicaoAdd () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: this.urlEdicao,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async iniciarEdicaoEdit (idMandato) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.urlEdicao}/${idMandato}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  ultimoMandato (tipoMandatoId) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: this.urlUltimo + '/' + tipoMandatoId,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
